module.exports = __webpack_public_path__ + "static/for-the-owner-visual-2x-92a00d4c26a71125af20cfb3764ae977.png";